import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    // FIX : le HTML re-fetché provient de la page produit standard, où les réglages
    // du bloc galerie (ex. affichage des miniatures) peuvent différer de ceux de cette
    // section. On aligne donc le nouveau HTML sur l'état de la galerie courante avant
    // de l'injecter : si la galerie actuelle n'affiche PAS de miniatures, on retire
    // celles du nouveau HTML pour qu'elles ne réapparaissent pas.
    const currentHasThumbnails = currentMediaGallery.querySelector('.product-media-gallery__thumbnails');
    if (!currentHasThumbnails) {
      const newThumbnails = newMediaGallery.querySelector('.product-media-gallery__thumbnails');
      if (newThumbnails) newThumbnails.remove();
    }

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);

      // Réactive les boutons AR (data-shopify-xr) présents dans le nouveau HTML
      window.ShopifyXR?.setupXRElements();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
